import { Button } from "../../../ui/Button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../ui/Popover";

import { DateTime } from "luxon";
import { Calendar } from "../../../ui/Calendar";
import { DataRow, TabOptions } from "../../../stores/TabsStore";
import { Column } from "react-data-grid";
import { t } from "i18next";
import { TbCheckbox, TbSelect, TbSquare, TbSquareCheck, TbSquareCheckFilled } from "react-icons/tb";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../ui/Separator";

type Props = {
  columns: readonly Column<DataRow, any>[],
  hiddenColumns: string[],
  onChange: (columns: string[]) => void;
};

const Columns = ({ columns, hiddenColumns, onChange }: Props) => {

  function handleCheck(columnName: string) {
    if (hiddenColumns.includes(columnName)) {
      onChange(hiddenColumns.filter(c => c !== columnName))
    } else {
      onChange([...hiddenColumns, ...[columnName]])
    }
  }


  function reset() {
    onChange([])
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex flex-none items-center">
          <Button variant="outline" size="datepicker" className="px-0 items-center">
            <span className="px-2">{t("columns")}</span>
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className="px-0 py-0 text-base h-[400px] overflow-hidden" align={"start"}>
        <ScrollArea className="h-full w-full">
        <div className="flex items-center justify-between px-3 h-10 py-2">
          <div className="leading-6 font-semibold">{t("columns")}</div>
          <Button variant="outline" size="xs" type="button" onClick={() => reset()}>
            {t("reset")}
          </Button>
        </div>
        <Separator/>
        {
          columns.length > 0 ? 
          <div className="py-2 flex flex-col space-y-1 px-3 ">
            {columns.filter(c => !["hidden"].includes(c.key)).map((i, idx) => (
              <div key={idx} className="px-1 py-1 rounded bg-muted flex justify-between items-center cursor-pointer hover:bg-primary hover:text-white" onClick={() => handleCheck(i.key)}>
                <div className="space-x-2 flex items-center px-1">
                  <span className="font-semibold text-xs">{idx + 1}</span>
                  <span>{i.name}</span>
                </div>
                {!hiddenColumns.includes(i.key) ? <TbSquareCheckFilled size={18} className="w-6 hover:text-white"/> : <TbSquare size={18} className="w-6 hover:text-white"/>}
              </div>
            ))}
          </div>
          :
          <div></div>
        }
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};

export default Columns;
